import {FC} from "react";
import {useApiCall} from "../../../../lib/src/api";
import {config} from "../../config";
import {ModalFooter} from "@jane/lib/src/components/layout/ModalProvider";

export const BulkUnpinLearnCategoryModal: FC<{ selected: string[], reload: () => void }> = (props) => {
  const {learn} = useApiCall(config)

  const save = async () => {
    const promises = props.selected.map(async (category) => {
      await learn.unpinCategory(category)
    })
    await Promise.all(promises)
    props.reload()
  }

  return <>
    <div>
      Categorieën los maken?
    </div>
    <ModalFooter text={'Opslaan'} onSubmit={save} />
  </>
}